import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-sector-icon',
  template: `
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_17784_441)">
        <path
          d="M27.9207 14.6668C27.3073 9.10683 22.894 4.6935 17.334 4.08016V1.3335H14.6673V4.08016C9.10732 4.6935 4.69398 9.10683 4.08065 14.6668H1.33398V17.3335H4.08065C4.69398 22.8935 9.10732 27.3068 14.6673 27.9202V30.6668H17.334V27.9202C22.894 27.3068 27.3073 22.8935 27.9207 17.3335H30.6673V14.6668H27.9207ZM16.0007 25.3335C10.8407 25.3335 6.66732 21.1602 6.66732 16.0002C6.66732 10.8402 10.8407 6.66683 16.0007 6.66683C21.1607 6.66683 25.334 10.8402 25.334 16.0002C25.334 21.1602 21.1607 25.3335 16.0007 25.3335Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_17784_441">
          <rect width="32" height="32" fill="currentColor" />
        </clipPath>
      </defs>
    </svg>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SectorIconComponent {}
